import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { withRouter } from "../../../providers/withRouter";
import { Link } from "react-router-dom";
import Tick from "../../../icons/tick.svg";
import Cross from "../../../icons/cross.svg";
import { getAlertas, getAllConsultores } from "../../../services";
import {
  daysDiff,
  formatoFechasEs,
} from "../../../functions/funciones";
import { Tabs, Tab, Box } from "@mui/material";
import TabPanel from "../../../components/tabs/Tabs";
import BreadCrumb from "../../../components/navbar/Breadcrumb";
import NoDocumentsAlert from "../../../components/alerts/noDocumentsAlert";
import WithDocumentsAlert from "../../../components/alerts/withDocumentsAlert";
import AllSuppAlert from "../../../components/alerts/allSuppAlert";
import { useLocation, useNavigate } from 'react-router-dom';
import {  construirURLParamsFiltros, useRecogerURLParamsFiltros } from './../../../functions/parametrosURL/funcionesParamsURL';
import WelcomeAlertSupps from "../../../components/alerts/welcomeAlertSupps";
import ValidDocsAlertSupps from "../../../components/alerts/validDocsAlertSupps";
import StandByAlertSupps from "../../../components/alerts/standByAlertSupps";

const Alertas = () => {
  const { t } = useTranslation(['suppliers', 'common']);

  const proveedoresRows = [
    {
      id: "proveedor_id",
      numeric: false,
      disablePadding: false,
      label: "",
    },
    {
      id: "proveedor_name",
      numeric: false,
      disablePadding: false,
      label: t('columns.supplier'),
      overrideFunc: (data, row) => <Link to={"/proveedores/" + row.nif}>{data}</Link>
    },
    {
      id: "ultimaReclamacion",
      numeric: false,
      disablePadding: false,
      label: t('columns.lastReclamation'),
      overrideFunc: (data, row) => <span style={{color: daysDiff(new Date(data), new Date()) > 30 ? 'red' : 'black'}}>{formatoFechasEs(data)}</span>
    },
    {
      id: "nif",
      numeric: false,
      disablePadding: false,
      label: t('common:form.nif'),
    },
    {
      id: "planificacionPreventiva",
      numeric: false,
      disablePadding: false,
      label: t('documentTypes.preventivePlanning').toUpperCase(),
      overrideFunc: (data) =>  <img style={{ width: "20px" }} src={data ? Cross : Tick} alt="vacio" />,

    },
    {
      id: "evaluacionRiesgos",
      numeric: false,
      disablePadding: false,
      label: t('documentTypes.riskAssessment').toUpperCase(),
      overrideFunc: (data) =>  <img style={{ width: "20px" }} src={data ? Cross : Tick} alt="vacio" />,
    },
    {
      id: "vigilancia",
      numeric: false,
      disablePadding: false,
      label: t('documents.vigilanciaSalud'),
      overrideFunc: (data) => data ? <span style={{color: daysDiff(new Date(data), new Date()) >= 0 ? 'red' : 'black'}}>{formatoFechasEs(data)}</span> : '-',
    },
    {
      id: "certificado",
      numeric: false,
      disablePadding: false,
      label: t('documents.certificadoSS'),
      overrideFunc: (data) => data ? <span style={{color: daysDiff(new Date(data), new Date()) >= 0 ? 'red' : 'black'}}>{formatoFechasEs(data)}</span> : '-',
    },
    {
      id: "justificante",
      numeric: false,
      disablePadding: false,
      label: t('documents.justificantePago'),
      overrideFunc: (data) => data ? <span style={{color: daysDiff(new Date(data), new Date()) >= 0 ? 'red' : 'black'}}>{formatoFechasEs(data)}</span> : '-',
    },
    {
      id: "seguro",
      numeric: false,
      disablePadding: false,
      label: t('documents.seguroRC'),
      overrideFunc: (data) => data ? <span style={{color: daysDiff(new Date(data), new Date()) >= 0 ? 'red' : 'black'}}>{formatoFechasEs(data)}</span> : '-',
      // overrideFunc: (row) => {
      //     console.log(row.find( d => d.tipoDoc === 2 )?.fechaCaducidad)

      // },
    },
  ];
  const location = useLocation();

  let params = new URLSearchParams(location.search);

  const tabParam = parseInt(params.get("valorTab") ) ;
  
  const urlPadre = window.location.pathname;
  const navigate = useNavigate();

  const { filtrosIniciales } = useRecogerURLParamsFiltros();

  const [Consultores, setConsultores] = useState([]);
  const [busqueda, setBusqueda] = useState(filtrosIniciales);
  const [loading, setLoading] = useState(true);
  const [recargar, setRecargar] = useState(false);
  const [limite, setLimite] = useState(0);
  const [value, setValue] = useState(tabParam || 0);
  // const [data, setData] = useState({
  //   meta: {},
  //   rows: [],
  // });
  

  // useEffect(() => {
  //   fetchData();
  //   getAllConsultores().then((res) => {
  //     setConsultores(res);
  //   });
  // }, [recargar]);



  // const fetchData = async ({ offset = 1, limit = limite, filtros } = {}) => {
  //   // setLimite(limit);
  //   // const payload = {
  //   //   // filtros:{ultimaReclamacion:new Date().setDate(new Date().getDate() - 60)},
  //   //   filtros,
  //   //   params: { page: offset, limit: limite },
  //   // };

  //   // try {
  //   //   setLoading(true);
      
  //   //   const response1 = await getAlertas(payload);
  //   //   const { meta, data} = response1;
  //   //   setData({
  //   //     meta,
  //   //     rows: formatData(data),
  //   //   });
  //   // } catch (error) {
  //   //   console.log(error);
  //   // } finally {
  //   //   setLoading(false);
  //   // }
  // };

  const formatData = (data) => {
    // data.map((row, i) => (
    //   console.log(row.docssupps?.find((d) => d.tipoDoc === 4)?.validado)
    // ))
    // return data.map((row, i) => ({
    //   proveedor_id: row.id,
    //   proveedor_name: row.razonSocial,
    //   ultimaReclamacion: row.ultimaReclamacion || row.createdAt,
    //   nif: row.nif,
    //   planificacionPreventiva:!row.docssupps?.find((d) => d.tipoDoc === 4)?.validado === true,
    //   evaluacionRiesgos:
    //     !row.docssupps?.find((d) => d.tipoDoc === 5)?.validado === true,
    //   vigilancia: row.docssupps?.find((d) => d.tipoDoc === 7)?.fechaCaducidad || '',
    //   certificado: row.docssupps?.find((d) => d.tipoDoc === 6)?.fechaCaducidad || '',
    //   justificante: row.docssupps?.find((d) => d.tipoDoc === 3)?.fechaCaducidad || '',
    //   seguro: row.docssupps?.find((d) => d.tipoDoc === 2)?.fechaCaducidad || '',
    // }));
  };
  
  // const filtrarDatos = (filtros) => {
  //   setBusqueda(filtros)
  //   fetchData({ offset: 1, limit: limite, filtros: filtros });
  // } 

  const handleChange = (event, newValue) => {
    setValue(newValue);
    const currentParams = new URLSearchParams(location.search);
    const currentFiltros = {};
    for (let [key, value] of currentParams) {
      if (key !== 'valorTab' && key !== 'pagina' && key !== 'limite' && key !== 'orden' && key !== 'ordenadoPor') {
        currentFiltros[key] = value;
      }
    }
    construirURLParamsFiltros(navigate, 1, limite || 50, currentFiltros, newValue);
  };

  return (
    <>
      <BreadCrumb
        rutas={[{ path: "/alertas", label: t('alerts.title') }]}
        style={{ margin: "0 10px" }}
      />
      <div className="listPage">
        <div className="gridCard">
          <div className="gridHead">
            {t('alerts.title').toUpperCase()}
            {/* <Link to="/consultores"><div className="gridHeadRight">{"<< volver al listado de Consultores"}</div></Link> */}
          </div>
          <Box sx={{ padding: '10px 40px', border: 'none' }}>
            <Tabs value={value} onChange={handleChange} aria-label="tabs example">
              { <Tab id="tab-bienvenida" style={{ color:"#92004D" }} label={t('alerts.welcome')} /> }
              { <Tab id="tab-validados" style={{ color:"#92004D" }} label={t('alerts.validate')} /> }
              { <Tab id="tab-todos" style={{ color:"#92004D" }} label={t('alerts.all')} /> }
              { <Tab id="tab-sin-documentos" style={{ color:"#92004D" }} label={t('alerts.withoutDocuments')} /> }
              { <Tab id="tab-con-documentos" style={{ color:"#92004D" }} label={t('alerts.withDocuments')} /> }
              { <Tab id="tab-standBy" style={{ color:"#92004D" }} label={t('alerts.standBy')} /> }
            </Tabs>
          </Box>
          <TabPanel value={value} index={0} aria-labelledby="tab-bienvenida">
            <WelcomeAlertSupps valorTab={0}/>
          </TabPanel>
          <TabPanel value={value} index={1} aria-labelledby="tab-validados">
            <ValidDocsAlertSupps valorTab={1}/>
          </TabPanel>
          <TabPanel value={value} index={2} aria-labelledby="tab-todos">
            <AllSuppAlert valorTab={2}/>
          </TabPanel>
          <TabPanel value={value} index={3} aria-labelledby="tab-sin-documentos">
            <NoDocumentsAlert valorTab={3}/>
          </TabPanel>
          <TabPanel value={value} index={4} aria-labelledby="tab-con-documentos">
            <WithDocumentsAlert valorTab={4}/>
          </TabPanel>
          <TabPanel value={value} index={5} aria-labelledby="tab-standBy">
            <StandByAlertSupps valorTab={5}/>
          </TabPanel>
        </div>
      </div>
      <style jsx="true">{`
        .css-1aquho2-MuiTabs-indicator {
          background-color: #92004D;
        }
    `}</style>
    </>
  );
};

export default withRouter(Alertas);
